import type { ErrorPageButtonsProps } from './types';

export const ErrorPageButtons: React.FC<ErrorPageButtonsProps> = ({ buttons }) => {
  if (!buttons) {
    return null;
  }

  return buttons.map((button) => (
    <div className="mt-5 text-center" key={`button-${button.label}`}>
      <a className="inline-block rounded px-4 py-1 bg-white/40 text-base uppercase tracking-wide no-underline hover:underline" href={button.href}>
        {button.label}
      </a>
    </div>
  ));
};
